<template>
  <div class="edm-export">
    <button class="btn" @click="isModalShow = true">
      <v-icon class="mr-2">get_app</v-icon>
      <span>匯出報表 </span>
    </button>
    <div class="edm-export__modal-wrap" v-if="isModalShow">
      <div class="edm-export__modal">
        <!-- head -->
        <div class="form-item py-5">
          <h3>匯出報表</h3>
        </div>
        <!-- body -->
        <div>
          <!-- 篩選日期區間 -->
          <div class="form-item py-5 d-flex">
            <div class="w-96px mr-50px">
              <h4>篩選日期區間</h4>
            </div>
            <div class="flex-grow-1 flex-basis-0 my-n2">
              <DateFilter
                buttonPlaceholder="請選擇日期區間"
                modalWidth="540px"
                :dateOfRegisterFilter.sync="filter.createdAtRange"
              ></DateFilter>
            </div>
          </div>
          <!-- 篩選國家別 -->
          <div class="form-item py-5 d-flex">
            <div class="w-96px mr-50px">
              <h4>篩選國家別</h4>
            </div>
            <div class="flex-grow-1 flex-basis-0 my-n2">
              <SimpleSelectWithSearchInput
                buttonPlaceholder="請選擇國家"
                buttonWidth="100%"
                modalWidth="100%"
                modalBodyHeight="208px"
                :options="countryOptions"
                :selectedValue.sync="filter.country"
                item-value="country"
                item-text="country"
              ></SimpleSelectWithSearchInput>
            </div>
          </div>
        </div>
        <!-- foot -->
        <div class="pa-5 text-right">
          <button class="btn w-100px mr-10px" @click="cancelHandler">
            取消
          </button>
          <button class="btn btn-primary w-100px" @click="exportHandler">
            匯出
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DateFilter from '@/components/F-1a__ADATA-members_Filter-StartEndDate.vue';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import Str from '@/services/str';

export default {
  components: {
    DateFilter,
    SimpleSelectWithSearchInput,
  },
  data: () => ({
    isModalShow: false,
    filter: {
      createdAtRange: [],
      country: null,
      token: null,
    },
  }),
  computed: {
    ...mapState('member', ['countryOptions']),
  },
  mounted() {
    this.token = this.$store.state.token;
  },
  methods: {
    cancelHandler() {
      this.clearFilter();
    },
    exportHandler() {
      window.open(`${process.env.VUE_APP_API_URL}/export/member?${Str.query(this.filter)}`);
      this.clearFilter();
    },
    clearFilter() {
      this.isModalShow = false;
      this.filter = {
        createdAtRange: [],
        country: null,
        token: null,
      };
    },
  },
};
</script>

<style lang="scss">
.edm-export {
  &__modal-wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(170, 170, 170, 0.7);
    z-index: 10;
  }
  &__modal {
    width: 720px;
    margin: 0 auto;
    margin-top: 168px;
    background-color: #fff;
    border-radius: 4px;
  }
}
</style>
